import { forwardRef } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import WarningIcon from '@mui/icons-material/WarningAmber';
import { SnackbarContent, Stack, type SnackbarContentProps } from '@mui/material';
import { NotificationType } from 'react-admin';
import { IconButton } from 'shared/mui/IconButtons';

const icons: Partial<Record<NotificationType, React.ReactElement>> = {
  success: <CheckCircleIcon color="success" fontSize="small" />,
  error: <ErrorIcon color="error" fontSize="small" />,
  warning: <WarningIcon color="warning" fontSize="small" />,
};

type NotificationContentProps = SnackbarContentProps & {
  type: NotificationType;
  onClose: () => void;
};

export const NotificationContent = forwardRef<HTMLDivElement, NotificationContentProps>(
  ({ action, message, type, onClose, ...props }, ref) => (
    <SnackbarContent
      {...props}
      action={
        <>
          {action}
          <IconButton onClick={onClose} size="small" sx={{ padding: 0 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
      message={
        <Stack alignItems="flex-start" direction="row" gap={1}>
          {icons[type]}
          <span>{message}</span>
        </Stack>
      }
      ref={ref}
    />
  ),
);

NotificationContent.displayName = 'NotificationContent';
